export function createComputationWorker() {
  return new Worker(new URL('./computation.worker.js', import.meta.url), { name: 'northstar-calibration' });
}
